import React from 'react';
import { TextInput, TextArea, CardList, SectionHeader } from './Fields';
import ImageUpload from './ImageUpload';

const TestimonialsEditor = ({ data, onChange }) => {
  const set = (key, val) => onChange({ ...data, [key]: val });

  return (
    <div>
      <SectionHeader title="Seção Depoimentos" />
      <TextInput label="Título" value={data.heading} onChange={v => set('heading', v)} />

      <CardList
        label="Depoimentos"
        value={data.items}
        onChange={v => set('items', v)}
        emptyCard={{ photo: '', quote: '', author: '', title: '' }}
        renderCard={(item, i, update) => (
          <div className="space-y-2">
            <ImageUpload label="Foto" value={item.photo} onChange={v => update({ photo: v })} />
            <TextArea label="Depoimento" value={item.quote} onChange={v => update({ quote: v })} rows={3} placeholder='"O sistema transformou nossa gestão..."' />
            <div className="grid grid-cols-2 gap-2">
              <TextInput label="Nome" value={item.author} onChange={v => update({ author: v })} />
              <TextInput label="Cargo" value={item.title} onChange={v => update({ title: v })} placeholder="Secretário de Planejamento" />
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default TestimonialsEditor;
